/** @format */

import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { File, MapsData, Order, User } from "../../../services";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import moment from "moment/moment";
import Loading from "../../../components/shared/Loading/Loading";
import { useWindowSize } from "../../../hooks/useWindowSize";
import { useAmplitude } from "../../../hooks/useAmplitude";
import { onDebounce, requestErrorDisplay } from "../../../utils";
import OrdersCreateDesktopView from "../../../components/orders/views/OrdersCreateDesktopView";
import OrdersParsingData from "../components/OrdersParsingData";
import { useLanguage } from "../../../context/LanguageContext";

const OrdersCopyPage = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const params = useParams();
  const { isMobile, isDesktop } = useWindowSize();
  const { amplitude } = useAmplitude();
  const { currentLanguage } = useLanguage();
  const { user } = useSelector((state) => state);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [orderId, setOrderId] = useState(
    params?.id ? params?.id : searchParams.get("id") ? searchParams.get("id") : null,
  );
  const [orderDraftId, setOrderDraftId] = useState(null);
  const [recipientUpdate, setRecipientUpdate] = useState(0);
  const [isLoadingGet, setLoadingGet] = useState(
    location.pathname !== `/orders/copy/${orderId}`,
  );
  const [isEditOrder, setEditOrder] = useState(
    location.pathname === `/orders/edit/${orderId}`,
  );
  const [isChangedTitleInMobile, setChangeTitleForMobile] = useState(false);
  const [isBackBtn, setBackBtn] = useState(0);

  // Default data
  const [orderDraft, setOrderDraft] = useState(null);
  const [countries, setCountries] = useState([]);
  const [categories, setCategories] = useState([]);
  const [types, setTypes] = useState([]);
  const [temperatures, setTemperatures] = useState([]);
  const [loadingTypes, setLoadingTypes] = useState([]);
  const [partners, setPartners] = useState([]);
  const [orderData, setOrderData] = useState(null);
  const [cargoDetails, setCargoDetails] = useState(null);

  const [errors, setErrors] = useState({});
  // FORM
  // Selected data
  const [countryFrom, setCountryFrom] = useState();
  const [countryTo, setCountryTo] = useState();
  const [citiesFrom, setCitiesFrom] = useState([]);
  const [citiesTo, setCitiesTo] = useState([]);
  const [cityFrom, setCityFrom] = useState();
  const [cityTo, setCityTo] = useState();
  const [pickUpDate, setPickUpDate] = useState();
  const [pickUpStartTime, setPickUpStartTime] = useState();
  const [pickUpEndTime, setPickUpEndTime] = useState();
  const [deliveryDate, setDeliveryDate] = useState();
  const [deliveryStartTime, setDeliveryStartTime] = useState();
  const [deliveryEndTime, setDeliveryEndTime] = useState();
  const [addressTo, setAddressTo] = useState();
  const [addressFrom, setAddressFrom] = useState();
  const [coordinatesFrom, setCoordinatesFrom] = useState("");
  const [coordinatesTo, setCoordinatesTo] = useState("");
  const [addressIdFrom, setAddressIdFrom] = useState("");
  const [addressIdTo, setAddressIdTo] = useState("");
  const [recipientName, setRecipientName] = useState("");
  const [recipientEmail, setRecipientEmail] = useState("");
  const [recipientPhone, setRecipientPhone] = useState();
  const [senderPhone, setSenderPhone] = useState();
  const [category, setCategory] = useState();
  const [type, setType] = useState();
  const [weight, setWeight] = useState("");
  const [volume, setVolume] = useState("");
  const [details, setDetails] = useState();
  const [copyCount, setCopyCount] = useState(1);
  const [price, setPrice] = useState(0);
  const [algoPrice, setAlgoPrice] = useState(0);
  const [isAlgoPrice, setIsAlgoPrice] = useState(false);
  const [netPrice, setNetPrice] = useState();
  const [distance, setDistance] = useState();
  const [temperature, setTemperatury] = useState();
  const [loadingType, setLoadingType] = useState();
  const [createLoading, setLoadingCreate] = useState(false);
  const [insurance, setInsurance] = useState(false);
  const [declaredPrice, setDeclaredPrice] = useState(0);
  const [insurancePrice, setInsurancePrice] = useState();
  const [minPickDate, setMinPickDate] = useState(new Date(new Date().setHours(0)));
  const [minDeliveryDate, setMinDeliveryDate] = useState();
  const [partner, setPartner] = useState([]);
  const [isTender, setIsTender] = useState(false);
  const [tenderDateEnd, setTenderDateEnd] = useState("");
  const [tenderStartTime, setTenderStartTime] = useState("");
  const [tenderEndTime, setTenderEndTime] = useState("");
  const [partnersForTender, setPartnersForTender] = useState([]);
  const [points, setPoints] = useState([]);
  const [routeDistance, setRouteDistance] = useState();
  const [routeDuration, setRouteDuration] = useState("");

  const [isСallСities, setIsСallСities] = useState(false);

  const [isActualCities, setIsActualCities] = useState(true);
  const [isCalculatePrice, setIsCalculatePrice] = useState(true);

  // files
  const [files, setFiles] = useState([]);
  const [fileInvoice, setInvoiceFile] = useState(null);

  //map
  const [isLoadingMap, setIsLoadingMap] = useState(false);
  const [routeData, setRouteData] = useState(null);
  const [routeStartCity, setRouteStartCity] = useState(null);

  const updatePrice = (newPrice) => {
    setPrice(newPrice);
  };

  const onResetPrice = () => {
    setAlgoPrice(0);
    setNetPrice(0);
    setDistance(0);
  };

  useEffect(() => {
    setIsActualCities(!(cityFrom?.isActual === false || cityTo?.isActual === false));
  }, [cityFrom, cityTo]);

  useEffect(() => {
    console.log("[[location.pathname !==]]", location.pathname !== `/orders/copy/${orderId}`);
    console.log("[[isLoadingGet]]", isLoadingGet);
  }, [isLoadingGet]);

  useEffect(() => {
    if (
      points.length === 0 &&
      cityFrom &&
      countryFrom &&
      cityTo &&
      countryTo &&
      category &&
      type &&
      weight &&
      volume
    ) {
      orderCalculation();
    } else if (points.length !== 0) {
      setAlgoPrice(0);
    }
  }, [points]);

  useEffect(() => {
    if (cityFrom?.id && cityTo?.id) {
      Order.getCalculateOrderPrice(cityFrom.id, cityTo.id)
        .then((response) => {
          setIsCalculatePrice(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [cityFrom, cityTo]);

  const getDefaultData = async () => {
    setLoadingGet(true);
    try {
      if ( user && user.id ) {
        await Order.getCountries(currentLanguage)
            .then((response) => {
              console.log("countries", response.data);
              setCountries(response.data);
            })
            .catch((error) => {
              console.log(error);
              toast.error(error);
            });
      } else {
        console.log ("Пользователь не определен")
        setCountries([]);
      }

      await Order.getCategories()
        .then((response) => {
          setCategories(response.data);
        })
        .catch((error) => {
          console.log(error);
          toast.error(error);
        });

      await Order.getTypes()
        .then((response) => {
          console.log("types", response.data);
          setTypes(response.data);
        })
        .catch((error) => {
          console.log(error);
          toast.error(error);
        });

      await Order.getTemperaturesDisc()
        .then((response) => {
          console.log("Temperatures", response.data);
          setTemperatures(response.data);
        })
        .catch((error) => {
          console.log(error);
          toast.error(error);
        });

      await Order.getLoadingTypesDisc()
        .then((response) => {
          console.log("Temperatures", response.data);
          setLoadingTypes(response.data);
        })
        .catch((error) => {
          console.log(error);
          toast.error(error);
        });
    } catch (e) {
      toast.error(t('ordersCreate.errors.dataLoadError'));
    } finally {
      setLoadingGet(false);
    }
  };

  useEffect(() => {
    getDefaultData();
  }, []);

  useEffect(() => {
    User.getPartners()
      .then((response) => {
        if (response.status === 200) {
          const filteredPartners = response.data
            .filter((partner) => partner.state === "Confirmed")
            .map((partner) => ({
              ...partner,
              name: partner.companyName,
            }));

          setPartners(filteredPartners);
        } else {
          console.log(t('ordersCreate.logs.partnerListEmpty'));
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    if (isСallСities) {
      const responseEvent = (cities) => {
        setCitiesFrom(cities);
        if (orderDraft?.CityIdFrom && !cityFrom) {
          setCityFrom(cities?.find((c) => c.id === orderDraft?.CityIdFrom));
        }
      };

      Order.getCities(currentLanguage, countryFrom.id)
        .then((res) => res.data)
        .then((data) => {
          const cities = data?.filter(city => city.name).sort((a, b) => a.name.localeCompare(b.name));
          responseEvent(cities);
        })
        .catch((error) => {
          requestErrorDisplay(error, t);
        })
        .finally(() => {
          setIsСallСities(false);
        });
    }
  }, [isСallСities, currentLanguage]);

  useEffect(() => {
    const responseEvent = (cities) => {
      setCitiesFrom(cities);
      if (orderDraft?.CityIdFrom && !cityFrom) {
        setCityFrom(cities?.find((c) => c.id === orderDraft?.CityIdFrom));
      }
    };

    if (citiesTo.length && countryFrom?.id && countryTo?.id === countryFrom.id) {
      responseEvent(citiesTo);
    } else if (countryFrom?.id) {
      Order.getCities(currentLanguage, countryFrom.id)
        .then((res) => res.data)
        .then((data) => {
          const cities = data?.filter(city => city.name).sort((a, b) => a.name.localeCompare(b.name));
          console.log("cities", cities);
          responseEvent(cities);
        })
        .catch((error) => {
          requestErrorDisplay(error, t);
        });
    }
  }, [countryFrom, currentLanguage]);

  useEffect(() => {
    const responseEvent = (cities) => {
      setCitiesTo(cities);
      if (orderDraft?.CityIdTo && !cityTo) {
        setCityTo(cities?.find((c) => c.id === orderDraft?.CityIdTo));
      }
    };
    if (citiesFrom.length && countryTo?.id && countryFrom?.id === countryTo.id) {
      responseEvent(citiesFrom);
    } else if (countryTo?.id) {
      Order.getCities(currentLanguage, countryTo.id)
        .then((res) => res.data)
        .then((data) => {
          const cities = data?.filter(city => city.name).sort((a, b) => a.name.localeCompare(b.name));
          console.log("cities", cities);
          responseEvent(cities);
        })
        .catch((error) => {
          requestErrorDisplay(error, t);
        });
    }
  }, [countryTo, currentLanguage]);

  useEffect(() => {
    setIsLoadingMap(true);

    const isAddressRoute = addressIdFrom && addressIdTo && coordinatesFrom && coordinatesTo;
    const routeMethod = isAddressRoute ? "getRouteByAddressId" : "getRoute";
    const routeParams = isAddressRoute
      ? [addressIdFrom, addressIdTo]
      : [cityFrom?.id, cityTo?.id];

    if ((isAddressRoute && addressIdFrom && addressIdTo) || (!isAddressRoute && cityFrom?.id && cityTo?.id)) {
      MapsData[routeMethod](...routeParams)
        .then((response) => {
          try {
            if (response) setRouteDistance(response.data.distance);
            let parsedData = JSON.parse(response.data.jsonData);

            if (
              (isAddressRoute && response.data.fromCityId !== addressIdFrom) ||
              (!isAddressRoute && response.data.fromCityId !== cityFrom?.id)
            ) {
              parsedData = parsedData.reverse();
            }

            if (response) {
              setRouteStartCity(response.data.fromCityId);
              setRouteData(parsedData);
            } else {
              setRouteData(null);
              console.log(`[${routeMethod}]`, null);
            }
            setIsLoadingMap(false);
          } catch (error) {
            console.error(t('expeditorOrdersCreate.errors.jsonParseError'), error); // Reusing key from similar page
            setRouteData(null);
            setIsLoadingMap(false);
          }
        })
        .catch((error) => {
          console.error(error);
          setIsLoadingMap(true);
          toast.error(t('common.toast.genericError'));
        });
    }
  }, [cityFrom, cityTo, addressIdFrom, addressIdTo, coordinatesFrom, coordinatesTo]);

  const addressList = [
    {
      countryId: countryFrom?.id,
      cityId: cityFrom?.id,
      address: addressFrom,
      shippingDate: pickUpDate ? moment(pickUpDate).format("YYYY-MM-DD") : null,
      shippingHourFrom: pickUpStartTime
        ? Number(moment(pickUpStartTime).format("HH"))
        : null,
      shippingHourTo: pickUpEndTime ? Number(moment(pickUpEndTime).format("HH")) : null,
      latLng: coordinatesFrom,
      type: 0,
      step: 1,
      isInterimPoint: false,
      recipientName: user.companyName,
      recipientPhoneNumber: senderPhone,
      recipientEmail: "",
    },
    ...points.map((point, index) => ({
      countryId: point.country.id,
      cityId: point.city.id,
      address: point.address ? point.address : "",
      shippingDate: point.shippingDate ? moment(point.shippingDate).format("YYYY-MM-DD") : null,
      shippingHourFrom: point.shippingHourFrom
        ? Number(moment(point.shippingHourFrom).format("HH"))
        : null,
      shippingHourTo: point.shippingHourTo
        ? Number(moment(point.shippingHourTo).format("HH"))
        : null,
      latLng: point.latLng,
      type: 1,
      step: index + 2,
      isInterimPoint: true,
      recipientName: point.recipientName,
      recipientPhoneNumber: point.recipientPhoneNumber,
      recipientEmail: point.recipientEmail,
    })),
    {
      countryId: countryTo?.id,
      cityId: cityTo?.id,
      address: addressTo,
      shippingDate: deliveryDate ? moment(deliveryDate).format("YYYY-MM-DD") : null,
      shippingHourFrom: deliveryStartTime
        ? Number(moment(deliveryStartTime).format("HH"))
        : null,
      shippingHourTo: deliveryEndTime
        ? Number(moment(deliveryEndTime).format("HH"))
        : null,
      latLng: coordinatesTo,
      type: 1,
      step: points.length + 2,
      isInterimPoint: false,
      recipientName: recipientName,
      recipientPhoneNumber: recipientPhone,
      recipientEmail: recipientEmail,
    },
  ];

  useEffect(() => {
    const fetchData = async () => {
      if (orderId) {
        OrdersParsingData(orderId, {
          setLoadingGet,
          setOrderData,
          setCargoDetails,
        });
      }
    };

    fetchData();
  }, [orderId]);

  const cargoInfo = useMemo(() => {
    if (!cargoDetails) return {};

    return {
      type: types.find((c) => c.value === cargoDetails.vehicleType),
      category: categories.find((c) => c.value === cargoDetails.category),
      temperature: temperatures.find((c) => c.id === cargoDetails.temperatureId),
      loadingType: loadingTypes.find((c) => c.id === cargoDetails.loadingTypeId),
      weight: cargoDetails?.weight,
      volume: cargoDetails?.volume,
    };
  }, [cargoDetails, types, temperatures, loadingTypes]);

  useEffect(() => {
    if (cargoInfo) {
      setType(cargoInfo.type);
      setCategory(cargoInfo.category);
      setTemperatury(cargoInfo.temperature);
      setLoadingType(cargoInfo.loadingType);
      setWeight(cargoInfo.weight);
      setVolume(cargoInfo.volume);
    }
  }, [cargoInfo]);

  const cityInfo = useMemo(() => {
    if (!orderData) return {};

    return {
      cityFrom: citiesFrom.find((c) => c.id === orderData.cityIdFrom),
      cityTo: citiesTo.find((c) => c.id === orderData.cityIdTo),
    };
  }, [orderData, citiesFrom, citiesTo]);

  useEffect(() => {
    if (cityInfo) {
      setCityFrom(cityInfo.cityFrom);
      setCityTo(cityInfo.cityTo);
    }
  }, [cityInfo]);

  useEffect(() => {
    if (!orderData?.addressList?.length) return;

    const firstPoint = orderData.addressList[0];
    const lastPoint = orderData.addressList[orderData.addressList.length - 1];

    setCountryFrom(countries.find((c) => c.id === firstPoint.countryId));
    setCountryTo(countries.find((c) => c.id === lastPoint.countryId));
    setAddressFrom(firstPoint?.address);
    setAddressTo(lastPoint?.address);
    setCoordinatesFrom(firstPoint.latLng);
    setCoordinatesTo(lastPoint.latLng);
    setRecipientName(lastPoint.recipientName || "");
    setRecipientPhone(lastPoint.recipientPhoneNumber || "");
    setRecipientEmail(lastPoint.recipientEmail || "");
    setSenderPhone(firstPoint.recipientPhoneNumber || "");

    const filteredPoints = orderData.addressList.slice(1, -1).map((item, index) => ({
      country: countries.find((c) => c.id === item.countryId) || {},
      city: "",
      tempCityId: item.cityId || "",
      address: item.address || "",
      latLng: item.latLng || "",
      type: item.type ?? 1,
      step: item.step ?? index + 1,
      isInterimPoint: item.isInterimPoint ?? false,
      recipientName: item.recipientName || "",
      recipientPhoneNumber: item.recipientPhoneNumber || "",
      recipientEmail: item.recipientEmail || "",
      cities: [],
    }));

    setPoints(filteredPoints);

    console.log("[ORDER DATA]", orderData);
  }, [orderData]);

  const formData = () => {
    return {
      userId: user.id,
      price: price,
      algoPrice: algoPrice,
      isAlgoPrice: isAlgoPrice,
      netPrice: price,
      countryIdFrom: countryFrom?.id,
      countryNameFrom: countryFrom?.name,
      cityNameFrom: cityFrom?.name,
      cityFromName: cityFrom?.name,
      cityIdFrom: cityFrom?.id,
      addressFrom: addressFrom,
      shippingDate: pickUpDate ? moment(pickUpDate).format("YYYY-MM-DD") : null,
      shippingHourFrom: pickUpStartTime ? Number(moment(pickUpStartTime).format("HH")) : null,
      shippingHourTo: pickUpEndTime ? Number(moment(pickUpEndTime).format("HH")) : null,
      recipientName: recipientName,
      recipientEmail: recipientEmail,
      recipientPhoneNumber: recipientPhone,
      countryIdTo: countryTo?.id,
      countryNameTo: countryTo?.name,
      cityIdTo: cityTo?.id,
      cityNameTo: cityTo?.name,
      addressTo: addressTo,
      latLng: coordinatesTo,
      unloadingDate: deliveryDate ? moment(deliveryDate).format("YYYY-MM-DD") : null,
      unloadingHourFrom: deliveryStartTime ? Number(moment(deliveryStartTime).format("HH")) : null,
      unloadingHourTo: deliveryEndTime ? Number(moment(deliveryEndTime).format("HH")) : null,
      details: details || t('ordersCreate.defaults.noDescription'),
      weight: weight ? String(weight).replace(",", ".") : null,
      volume: volume ? String(volume).replace(",", ".") : null,
      category: category?.value,
      vehicleType: type?.value,
      loadingTypeId: loadingType?.id,
      temperatureId: temperature?.id,
      isInsurance: insurance,
      declaredPrice: declaredPrice,
      insurancePrice: insurancePrice,
      copyCount: copyCount,
      isActualCities: isActualCities,
      expeditorId: partner.userId,
      expeditors: partnersForTender.map(partner => partner.userId),
      tenderDateEnd: tenderDateEnd,
      addressList: addressList,
      isExistInterimPoint: points.length > 0,
      distance: routeDistance ? routeDistance : 0,
      type: 0,
      isPublic: true,
      isCommission: false,
      commission: 0,
    };
  };
  const formDataTender = () => {
    return {
      order: {
        userId: user.id,
        price: price,
        algoPrice: algoPrice,
        isAlgoPrice: isAlgoPrice,
        netPrice: price,
        countryIdFrom: countryFrom?.id,
        countryNameFrom: countryFrom?.name,
        cityNameFrom: cityFrom?.name,
        cityFromName: cityFrom?.name,
        cityIdFrom: cityFrom?.id,
        addressFrom: addressFrom,
        shippingDate: pickUpDate ? moment(pickUpDate).format("YYYY-MM-DD") : null,
        shippingHourFrom: pickUpStartTime
          ? Number(moment(pickUpStartTime).format("HH"))
          : null,
        shippingHourTo: pickUpEndTime ? Number(moment(pickUpEndTime).format("HH")) : null,
        recipientName: recipientName,
        recipientEmail: recipientEmail,
        recipientPhoneNumber: recipientPhone,
        countryIdTo: countryTo?.id,
        countryNameTo: countryTo?.name,
        cityIdTo: cityTo?.id,
        cityNameTo: cityTo?.name,
        addressTo: addressTo,
        latLng: coordinatesTo,
        unloadingDate: deliveryDate ? moment(deliveryDate).format("YYYY-MM-DD") : null,
        unloadingHourFrom: deliveryStartTime
          ? Number(moment(deliveryStartTime).format("HH"))
          : null,
        unloadingHourTo: deliveryEndTime
          ? Number(moment(deliveryEndTime).format("HH"))
          : null,
        details: details || t('ordersCreate.defaults.noDescription'),
        weight: weight ? String(weight).replace(",", ".") : null,
        volume: volume ? String(volume).replace(",", ".") : null,
        category: category?.value,
        vehicleType: type?.value,
        loadingTypeId: loadingType?.id,
        temperatureId: temperature?.id,
        isInsurance: insurance,
        declaredPrice: declaredPrice,
        insurancePrice: insurancePrice,
        copyCount: copyCount,
        isActualCities: isActualCities,
        expeditorId: partner.userId,
        addressList: addressList,
        isExistInterimPoint: points.length > 0,
        distance: routeDistance ? routeDistance : 0,
        type: 0,
        isPublic: false,
        isCommission: false,
        commission: 0
      },
      expeditors: partnersForTender.map((partner) => partner.userId),
      tenderDateEnd: tenderDateEnd
        ? ( tenderDateEnd ? moment(tenderDateEnd).format("YYYY-MM-DD") : null )
        : ( pickUpDate ? moment(pickUpDate).format("YYYY-MM-DD") : null ),
    };
  };

  const createDraftOrder = (withAlert = false) => {
    const orderType = orderDraftId ? "updateDraft" : "createDraft";
    const data = isTender ? formDataTender() : formData();

    Order[orderType](data, orderDraftId)
      .then((res) => res.data)
      .then((response) => {
        let oId = orderDraftId;
        if (!oId) {
          oId = response.id;
          setOrderDraftId(oId);
        }
        if (insurance && fileInvoice?.name) {
          uploadFile(oId, fileInvoice);
        }
        if (files.length) {
          files.forEach((f) => uploadFile(oId, f, 5));
        }
        if (withAlert) {
          toast.success(t('ordersCreate.toast.savedToDrafts'));
        }
      })
      .catch((error) => {
        console.log(error);
        requestErrorDisplay(error, t, 'ordersCreate.errors.createDraftError');
      });
  };

  const saveDraft = (withOutDebounce = false) => {
    if (withOutDebounce) {
      createDraftOrder(true);
    } else {
      onDebounce(() => createDraftOrder(false), 400);
    }
  };

  const createOrder = () => {
    const data = isTender ? formDataTender() : formData();
    setLoadingCreate(true);
    console.log("[CREATE ORDER DATA]", data);

    const request = isEditOrder
    ? Order.update(orderId, data)
    : isTender
    ? Order.createTender(data)
    : Order.create(data);

    request
      .then((res) => res.data)
      .then((response) => {
        amplitude.createOrder(response.id, insurance, response.createdAt);
        setLoadingCreate(false);
        if (insurance && fileInvoice?.name) uploadFile(response.id, fileInvoice);
        if (files.length) {
          files.forEach((f) => uploadFile(response.id, f, 5));
        }
        toast.success(isEditOrder ? t('ordersCopy.toast.orderEdited') : t('ordersCreate.toast.orderCreated'));
        navigate(`/main`);
      })
      .catch((error) => {
        console.log(error);
        setLoadingCreate(false);
        requestErrorDisplay(error, t, 'common.toast.genericError');
      });
  };

  const orderCalculation = () => {
    if (points.length !== 0) {
      return;
    }
    const data = {
      cityIdFrom: cityFrom.id,
      cityIdTo: cityTo.id,
      weight: String(weight).replace(",", "."),
      volume: String(volume).replace(",", "."),
      transportType: type.value,
      cargoCategory: category.value,
    };

    Order.getOrderPrice(data)
      .then((response) => {
        if (response.status == 200) {
          if (isDesktop)
            amplitude.orderCalculatePrice(
              response.data.price,
              response.data.netPrice,
              data,
              insurance,
            );
          // setPrice(response.data.price);
          setAlgoPrice(response.data.price);
          // setNetPrice(response.data.netPrice);
          setDistance(response.data.distance);
        } else {
          console.log(response);
          toast.error(t('ordersCreate.errors.calculationError'));
        }
      })
      .catch((error) => {
        console.log(error);
        // requestErrorDisplay(error, t, 'common.toast.genericError')
      });
  };

  const uploadFile = (orderId, file, type = 0) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("type", type);
    formData.append("orderId", orderId);
    Promise.all([File.addOrderDoc(formData)])
      .then(() => {
        toast.info(t('ordersCreate.toast.fileUploaded'));
      })
      .catch((error) => {
        console.log(error);
        requestErrorDisplay(error, t, 'ordersCreate.errors.uploadFileError');
      });
  };

  const queryInsurance = () => {
    if (insurance) {
      setInsurance(false);
      setDeclaredPrice(0);
      setInsurancePrice(null);
      setInvoiceFile({});
    } else {
      setInsurance(true);
    }
  };
  const calcInsurance = (val) => {
    setDeclaredPrice(val);
    if (+val) setInsurancePrice(Math.trunc((+val / 100) * 0.3));
    else setInsurancePrice(null);
  };

  if (isLoadingGet) {
    return <Loading inBlock />;
  }

  if (
    isEditOrder &&
    orderData?.status !== "moderation" &&
    orderData?.status !== "awaiting_payment" &&
    orderData?.status !== "rejected" &&
    orderData?.status !== "canceled"
  ) {
    return (
      <div className="alert alert-warning text-center" role="alert">
        <strong>{t('common.warning')}</strong> {t('ordersCopy.errors.editNotAllowed')}
      </div>
    );
  }

  const getPropsData = () => ({
    setCountryFrom,
    setCityFrom,
    countries,
    countryFrom,
    citiesFrom,
    cityFrom,
    countryTo,
    setCountryTo,
    setCityTo,
    citiesTo,
    cityTo,
    pickUpDate,
    pickUpStartTime,
    pickUpEndTime,
    minPickDate,
    setPickUpDate,
    setPickUpStartTime,
    setPickUpEndTime,
    deliveryDate,
    deliveryStartTime,
    deliveryEndTime,
    minDeliveryDate,
    setDeliveryDate,
    setDeliveryStartTime,
    setDeliveryEndTime,
    types,
    setType,
    setTemperatury,
    type,
    addressTo,
    setAddressTo,
    setRecipientPhone,
    setRecipientName,
    recipientName,
    recipientUpdate,
    setRecipientEmail,
    addressFrom,
    setAddressFrom,
    setRecipientUpdate,
    volume,
    setVolume,
    weight,
    setWeight,
    categories,
    category,
    setCategory,
    temperatures,
    temperature,
    loadingTypes,
    loadingType,
    setLoadingType,
    details,
    setDetails,
    insurance,
    queryInsurance,
    declaredPrice,
    calcInsurance,
    fileInvoice,
    setInvoiceFile,
    files,
    setFiles,
    distance,
    price,
    netPrice,
    algoPrice,
    insurancePrice,
    createLoading,
    copyCount,
    setCopyCount,
    createOrder,
    orderCalculation,
    onResetPrice,
    saveDraft,
    updatePrice,
    setIsСallСities,
    isCalculatePrice,
    isLoadingMap,
    routeData,
    routeStartCity,
    partners,
    setPartner,
    partner,
    isTender,
    setIsTender,
    tenderDateEnd,
    tenderStartTime,
    tenderEndTime,
    setTenderDateEnd,
    setTenderStartTime,
    setTenderEndTime,
    partnersForTender,
    setPartnersForTender,
    setCoordinatesFrom,
    setCoordinatesTo,
    coordinatesFrom,
    coordinatesTo,
    addressIdFrom,
    addressIdTo,
    setAddressIdFrom,
    setAddressIdTo,
    points,
    setPoints,
    setSenderPhone,
    setRouteDistance,
    setRouteDuration,
  });

  return (
    <>
      {/* {isDesktop && ( */}
        <OrdersCreateDesktopView
          {...getPropsData()}
          onPriceChange={setPrice}
          errors={errors}
          setErrors={setErrors}
          isCopy
          headTitle={isEditOrder ? t('ordersCopy.title.edit') : t('ordersCopy.title.copy')}
        />
      {/* )} */}
      {/* {isMobile && (
        <OrdersCreateMobileView
          {...getPropsData()}
          setChangeTitleForMobile={setChangeTitleForMobile}
          isChangedTitleInMobile={isChangedTitleInMobile}
          isBackBtn={isBackBtn}
          onPriceChange={updatePrice}
        />
      )} */}
    </>
  );
};

export default OrdersCopyPage;
